import type { AppTheme } from "../../app/providers/ThemeProvider";
import type { Md3Expressive } from "../../theme/md3Expressive";

type ShapeKey = keyof Md3Expressive["shape"];
type TypographyRole = keyof Md3Expressive["typography"];

export function getMd3Shape(theme: AppTheme, key: ShapeKey): number {
  return theme.md3.shape[key];
}

export function getMd3TypographyCss(
  theme: AppTheme,
  role: TypographyRole
): string {
  const t = theme.md3.typography[role];
  return `
    font-family: ${theme.font.familyHeading};
    font-size: ${t.fontSize}px;
    line-height: ${t.lineHeight}px;
    font-weight: ${t.fontWeight};
  `;
}

export function md3StateLayer(color: string, opacity: number): string {
  return `color-mix(in srgb, ${color} ${Math.round(
    opacity * 100
  )}%, transparent)`;
}

export function md3PressTransition(theme: AppTheme): string {
  const { duration, easing } = theme.md3.motion;
  return `transform ${duration.short4}ms ${easing.expressive}, box-shadow ${duration.short4}ms ${easing.standard}, background ${duration.short3}ms ${easing.standard}`;
}

export function md3CardRadius(theme: AppTheme): number {
  return getMd3Shape(theme, theme.md3.components.card.shape);
}

export function md3ButtonRadius(theme: AppTheme): number {
  return getMd3Shape(theme, theme.md3.components.filledButton.shape);
}

export function md3FieldRadius(theme: AppTheme): number {
  return getMd3Shape(theme, theme.md3.components.outlinedTextField.shape);
}
